import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=096086b6&scoped=true"
import script from "./FormButtons.vue?vue&type=script&lang=js"
export * from "./FormButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096086b6",
  null
  
)

export default component.exports